import React from 'react';
import classNames from 'classnames/bind';
import { Link } from '@reach/router';

import styles from './MainHeroMassage.module.scss';

let cx = classNames.bind(styles);

const MainHeroMassage = () => {
	return (
		<section id='inicio' className={cx({ main_hero: true })}>
			<div className='container mx-auto h-screen flex flex-col justify-center items-center lg:flex-row lg:justify-start lg:items-center'>
				<div
					className={cx({
						trans_box: true,
						'flex flex-col w-10/12 lg:w-2/5 p-10 mt-32': true,
					})}
				>
					<h1 className=' text-3xl lg:text-5xl leading-none font-bold font-Ubuntu-Bold'>
						En CCU <br /> nos apasiona
					</h1>
					<h3 className='text-xl lg:text-2xl leading-none font-Roboto-Light pt-1'>
						crear experiencias para compartir <br /> juntos un mejor vivir.
					</h3>
					<div className='flex flex-row'>
					<a
						href='https://postulacionesccuargentina.hiperjob.com/ofertas'
						target='_blank'
						rel='noopener noreferrer'
						className='text-xl lg:text-3xl my-4 font-bold border-2 border-ccu-green px-2'
					>
						Te invitamos a ser CCU
					</a>
					</div>
				</div>
			</div>
		</section>
	);
};

export default MainHeroMassage;
